var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { styledComponents } from '@datashop/theme';
var styled = styledComponents.default, withProps = styledComponents.withProps;
var fontSizeMap = {
    h1: 40,
    h2: 32,
    h3: 28,
    h4: 20,
    h5: 16,
    h6: 12,
};
var fontWeightMap = {
    h1: 400,
    h2: 600,
    h3: 400,
    h4: 600,
    h5: 700,
    h6: 800,
};
var lineHeightMap = {
    h1: 48,
    h2: 48,
    h3: 40,
    h4: 32,
    h5: 24,
    h6: 24,
};
var Wrapper = withProps(styled.div)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var withMargin = _a.withMargin, inline = _a.inline, as = _a.as;
    return "\n      display: " + (inline ? 'inline-block' : 'block') + ";\n      margin-bottom: " + (withMargin ? '12px' : '0') + ";\n      font-size: " + fontSizeMap[as] + "px;\n      font-weight: " + fontWeightMap[as] + ";\n      line-height: " + lineHeightMap[as] + "px;\n    ";
});
var Heading = function (_a) {
    var children = _a.children, withMargin = _a.withMargin, as = _a.as, inline = _a.inline, props = __rest(_a, ["children", "withMargin", "as", "inline"]);
    return (React.createElement(Wrapper, __assign({ withMargin: withMargin, as: as, inline: inline }, props), children));
};
Heading.defaultProps = {
    as: 'h1',
    withMargin: false,
    inline: false,
};
export { fontSizeMap };
export default Heading;
var templateObject_1;
//# sourceMappingURL=Heading.js.map